import { inject, Injectable } from '@angular/core';
import { IndexedDbResourceLocation, IndexedDbService } from '@softline/core';
import { lastValueFrom } from 'rxjs';
import { StempelBody } from '../types/stempel-body';

@Injectable()
export class StempelIndexedDbRepository {
  private readonly indexedDbService = inject(IndexedDbService);

  private readonly DATABASE_NAME = 'stempel-terminal';
  private readonly OBJECT_STORE_NAME = 'offline-stempel';

  private createLocation(key?: string): IndexedDbResourceLocation {
    return {
      key,
      objectStoreName: this.OBJECT_STORE_NAME,
      databaseName: this.DATABASE_NAME,
    };
  }

  async loadAll(): Promise<StempelBody[]> {
    const location = this.createLocation();
    return await lastValueFrom(this.indexedDbService.get(location));
  }

  async add(stempel: StempelBody): Promise<void> {
    const location = this.createLocation(stempel.time);
    this.indexedDbService.create(location, stempel);
  }

  async clear(): Promise<void> {
    this.indexedDbService.delete(this.createLocation());
  }
}
